import { fetchJson$, fetchJson } from '@atlassian/jira-fetch';
import { getUserAuthUrl } from '@atlassian/jira-issue-fetch-services-common';
import { IssueViewFetchError } from '@atlassian/jira-issue-view-errors';

// eslint-disable-next-line jira/export/no-external-exports
export { getUserAuthUrl };

export const fetchUserAuth$ = (baseUrl: string) =>
	fetchJson$(getUserAuthUrl(baseUrl)).catch((error) => {
		throw new IssueViewFetchError(error, getUserAuthUrl('{baseUrl}'));
	});

export const fetchUserAuth = (baseUrl: string) => fetchJson(getUserAuthUrl(baseUrl));
